export default "__VITE_ASSET__BU8Oo1MP__"